package com.shadowings.gero.presentation.screen.characters

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.presentation.component.GeroButton
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.reset_btn
import org.jetbrains.compose.resources.stringResource

@Composable
fun ColorsPicker(
    sections: List<ColorSectionData>,
    onResetClick: (() -> Unit)? = null,
    headerContent: (@Composable () -> Unit)? = null,
) {
    LazyColumn(
        modifier = Modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(24.dp)
    ) {
        if (headerContent != null) {
            item {
                headerContent()
            }
        }
        items(sections.size) {
            val section = sections[it]
            ColorSection(
                title = section.title,
                options = section.options,
                selectedIndex = section.selectedIndex,
                onSelect = { index ->
                    section.onSelect.invoke(index)
                }
            )
        }
        if (onResetClick != null) {
            item {
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    GeroButton(
                        title = stringResource(Res.string.reset_btn),
                        onClick = onResetClick,
                        modifier = Modifier.padding(vertical = 16.dp),
                        testTagId = "colors_picker_reset_btn"
                    )
                    Spacer(Modifier.height(32.dp))
                }
            }
        }
    }
}